interface AddressLocodeAndCustomFieldsProps {
  un_locode?: string;
  location_reference_number?: string;
  custom_address_reference?: string;
  un_locode_className?: string;
}

export default function AddressLocodeAndCustomFields({
  un_locode,
  location_reference_number,
  custom_address_reference,
  un_locode_className,
}: AddressLocodeAndCustomFieldsProps) {
  return (
    <div className="mt-xss">
      {un_locode && (
        <div className={`${un_locode_className} font-b3 font-roboto text-secondary mb-xxs`}>UN/LOCODE: {un_locode}</div>
      )}
      {(location_reference_number || custom_address_reference) && (
        <div className="font-b3 font-roboto text-secondary">
          {location_reference_number}
          {location_reference_number && custom_address_reference ? " | " : ""}
          {custom_address_reference}
        </div>
      )}
    </div>
  );
}

AddressLocodeAndCustomFields.defaultProps = {
  un_locode: undefined,
  location_reference_number: undefined,
  custom_address_reference: undefined,
  un_locode_className: undefined,
};
